
import { Component, OnInit } from '@angular/core';
import { ActivitylogService } from '../services/activitylog/activitylog.service';
import { SessionStorageService } from 'ngx-webstorage';
import { CommonModule } from '@angular/common';
import { JsonDataService } from '../services/commonData/json-data.service';

// Angular Material modules
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { ReactiveFormsModule, FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-view-profile',
  standalone: true,
  templateUrl: './view-profile.component.html',
  styleUrls: ['./view-profile.component.css'],
  imports: [
    CommonModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatIconModule,
    MatSelectModule,
    ReactiveFormsModule
  ]
})
export class ViewProfileComponent implements OnInit {
  form!: FormGroup;
  userRights: string[] = [];
  int_designation: any;

  constructor(
    private fb: FormBuilder,
    private sessionStorage: SessionStorageService,
    public activityLog: ActivitylogService,
    private jsonDataService: JsonDataService
  ) {}

  ngOnInit() {
    this.form = this.fb.group({
      userID: [this.sessionStorage.retrieve('userId')],
      userName: [this.sessionStorage.retrieve('userName')],
      userRole: [this.sessionStorage.retrieve('userRole')],
      userDepartment: [this.sessionStorage.retrieve('userDepartment')],
      designation: [this.sessionStorage.retrieve('designation')]
    });

    this.userRights = this.sessionStorage.retrieve('rightsArray') || [];

    // Get designation metadata from JSON
    this.jsonDataService.getValueFromJSON()
      .then((res: any) => {
        this.int_designation = res.UserFormField.find((x: any) => x.Name === 'designation');
      })
      .catch(err => console.error('Error fetching JSON data:', err));
  }
}

